// extracted by mini-css-extract-plugin
module.exports = {"latest-list":"styles-m__latest-list__1DXlo","li-list":"styles-m__li-list__2hfeZ","ul-grid":"styles-m__ul-grid__1fTJ-","footer-title":"styles-m__footer-title__3jAKh"};